import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { App } from "@capacitor/app";
import { Platform } from "@ionic/angular";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { ApiVersion } from "src/model/interface/api-version";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { LoggerService } from "src/service/logger.service";
import { UtilityService } from "src/service/utility.service";

@Component({
    selector: "app-options-version",
    templateUrl: "./options-version.component.html",
    styleUrls: ["./options-version.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OptionsVersionComponent implements OnInit, OnDestroy, iEvent {
  private _logContext: string = "Options-version.component";

  private _connectionAddress: string = "";
  private _lblServerNotReachable: string = "**";
  private _translateSubscription: Subscription = null;
  _eventSubscriptions: Array<Subscription> = null;

  public appCurrentVersion: string = "";
  public serverCurrentVersion: string = "";
  public isReachable: boolean = false;

  constructor(
    private _platform: Platform,
    private _utilityService: UtilityService,
    private _loggerService: LoggerService,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this._connectionAddress = environment.httpServerRoot;

    this.subscribeEvents();
    this.loadCurrentAppVersion();
    this.loadServerVersion();

  }

  ngOnDestroy(): void {
    if (this._translateSubscription) {
      this._translateSubscription.unsubscribe();
    }
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnServerRootChanged.pipe(
        filter((newConnectionAddress: string) => newConnectionAddress !== "")
      ).
        subscribe(
          (newConnectionAddress: string) => {
            this._connectionAddress = newConnectionAddress
            this.loadServerVersion();
          }
        )
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }

  //#endregion


  /**
   * Get if device is Android or iOS devices
   *
   * @returns
   */
  public isSmmartPhoneDevice(): boolean {
    return this._platform.is("ios") || this._platform.is("android");
  }

  /**
   * Load current application version
   */
  private loadCurrentAppVersion(): void {
    if (this._platform.is("ios") || this._platform.is("android")) {
      try {
        App.getInfo().then((info) => {
          this.appCurrentVersion = info.version;
        });
      } catch (error) { }
    }
  }//

  /**
   * Get current server version
   */
  private async loadServerVersion(): Promise<void> {
    this.serverCurrentVersion = "";

    if (this._connectionAddress !== "") {
      try {
        const fullServerVersiont: ApiVersion =
          await this._utilityService.getSoftwareServerVersion();

        this.serverCurrentVersion =
          fullServerVersiont.majorVersion +
          "." +
          fullServerVersiont.minorVersion +
          "." +
          fullServerVersiont.buildVersion;

        this.isReachable = true;

      } catch (exception) {
        this._loggerService.log(LogLevel.LOG_ERROR, this._logContext, this._logContext, "loadServerVersion()", "ERROR: " + exception.message);
        this.isReachable = false;
      }
    } else {
      this.isReachable = false;
    }
  }
}
